import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  datosRuta = {
    inicio: '',
    tipoInicio: '',
    totemInicio: '',
    destino: '',
    tipoDestino: '',
    dateConnection: ''
  };
  constructor() { }

  setInicio(inicio: any, tipoInicio: string, totemInicio: any) {
    this.datosRuta.inicio = inicio;
    this.datosRuta.tipoInicio = tipoInicio;
    this.datosRuta.totemInicio = totemInicio;

    localStorage.setItem('nodos', JSON.stringify( this.datosRuta ) );
  }

  setDestino(destino: string, tipoDestino: string) {
    this.datosRuta.destino = destino;
    this.datosRuta.tipoDestino = tipoDestino;

    localStorage.setItem('nodos', JSON.stringify( this.datosRuta ) );
  }

  setDateLocal(fecha: string) {
    this.datosRuta.dateConnection = fecha;
    localStorage.setItem('nodos', JSON.stringify( this.datosRuta ) );
  }

  getNodosRuta() {
    const result = localStorage.getItem('nodos');
    return JSON.parse(result);
  }

}
